export default "__VITE_ASSET__CGIsphSJ__"